import React, { useState, useContext } from "react"

import Button from "components/UI/Button"
import InputBox from "components/UI/InputBox"
import { css } from "@emotion/core"
import t from "theme"
import AuthFunction from "components/Auth/AuthFunction"
import FirebaseContext from "components/Common/FirebaseContext"
import BeatLoader from "react-spinners/BeatLoader"

const PasswordlessBox = ({
    inputPlaceholder,
    buttonText,
    inputStyle,
    buttonStyle,
    flex = false,
    setLoading,
    ...props
}) => {
    let formvalue
    const firebase = useContext(FirebaseContext)
    const [localLoading, setLocalLoading] = useState(false)

    return (
        <div
            css={css`
                display: ${flex ? "flex" : "block"};
            `}
            {...props}>
            <InputBox
                placeholder={inputPlaceholder ? inputPlaceholder : "E-MAIL"}
                onChange={form => {
                    formvalue = form.target.value
                }}
                css={
                    inputStyle
                        ? inputStyle
                        : css`
                              width: 13rem;
                              display: block;
                              margin-bottom: ${t.space[1]};
                          `
                }
            />

            <Button
                onClick={() => {
                    if (setLoading) {
                        setLoading(true)
                    } else {
                        setLocalLoading(true)
                    }
                    AuthFunction({ firebase: firebase, command: "signin", provider: "emailpw", email: formvalue })

                    alert("Thank you for signing up! Please check your email for a login link.")

                    if (setLoading) {
                        setLoading(false)
                    } else {
                        setLocalLoading(false)
                    }
                }}
                css={
                    buttonStyle
                        ? buttonStyle
                        : css`
                              width: 13rem;
                          `
                }>
                {buttonText ? buttonText : "Join"}
            </Button>
            <BeatLoader loading={localLoading} size={10} color={t.color.subtlegrey} />
        </div>
    )
}

export default PasswordlessBox
